export class FetchError extends Error {
    response: Response;
  
    constructor(response: Response) {
      super(response ? `Request failed with status code ${response.status}` : 'Network Error');
      this.response = response;
    }
  }